/**
 * The page's side of the service worker (`src/sw/sw.ts`, roadmap item
 * app-installable): it keeps the app's own files; the platform's answers are
 * kept by the page itself (`api/storedReads.ts`).
 */

/**
 * Registers `/sw.js` once the page has loaded. Only a built app has one (the
 * dev server does not), and a browser without service workers simply has an
 * app that needs its connection, as before.
 */
export function registerServiceWorker() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
